import { backendUrl } from '../constants/urls';
import clientApi from '../constants/urls';

const retrieveFloatRequest = (query = '') => {
	return clientApi.get(`${backendUrl}/admin/transactions/all/floats/requests${query || ''}`);
};

const floatRequestActions = (id, category) => {
	return clientApi.post(`${backendUrl}/businessCategory/${id}`, category);
};

const floatRequestService = {
	retrieveFloatRequest,
	floatRequestActions,
};

export default floatRequestService;
